const CLIENT_ID = import.meta.env.VITE_CLIENT_ID || "25Vp8P0aF9OATNaEIUCSrwksYmHkeZckQaaoH2fW";
const CLIENT_SECRET =
  import.meta.env.VITE_CLIENT_SECRET ||
  "Wcn6WkzssrZUNvkC2UpJVhUMRHfVk5MFQhrYm9wmustsmSRAYq3a4Waun7LLOiivpZxuMa5yxMVpHYC2jYsmUQiUVk2teK9M40SAmEpXkrLQqgYrYcaThbLWHpn3d7dI";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:8888";
const SENTRY_DSN =
  import.meta.env.VITE_SENTRY_DSN ||
  "https://0422b77b808b8f4006eb82d5f3de0888@o327377.ingest.us.sentry.io/4507458630057984";
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || "development";
export default {
  API_BASE_URL,
  CLIENT_ID,
  CLIENT_SECRET,
  SENTRY_DSN,
  ENVIRONMENT,
};
